// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryMutateHook on POST /fan-follow/accept.

import {
  useMutation,
  useQueryClient,
  type QueryClient,
  type UseMutationOptions,
} from "@tanstack/react-query";
import type {
  typeFanFollowAcceptBody,
  typeFanFollowAcceptOutput200,
} from "../../sdk/fanFollow/postFanFollowAccept";
import useCallSdk from "../../sdk-helpers/useCallSdk";

type Options = Omit<
  UseMutationOptions<
    typeFanFollowAcceptOutput200,
    unknown,
    typeFanFollowAcceptBody,
    unknown
  >,
  "mutationFn"
>;

let invalidationTimer: ReturnType<typeof setTimeout> | null = null;

// 150ms of silence before invalidating: a burst of mutations (a row action
// repeated across a table selection) triggers one refetch, not one per call.
export function invalidateRelated({
  queryClient,
}: {
  queryClient: QueryClient;
}): void {
  if (invalidationTimer) {
    clearTimeout(invalidationTimer);
  }
  invalidationTimer = setTimeout(() => {
    void queryClient.invalidateQueries({
      queryKey: ["post:profile:profileGetForAccount", "svc:profile-api"],
    });
    void queryClient.invalidateQueries({
      queryKey: ["post:fanFollow:fanFollowRequestsList", "svc:profile-api"],
    });
    void queryClient.invalidateQueries({
      queryKey: ["post:fanFollow:fanFollowFollowersList", "svc:profile-api"],
    });
    void queryClient.invalidateQueries({
      queryKey: ["post:fanFollow:fanFollowRequestCount", "svc:profile-api"],
    });
  }, 150);
}

export default function useFanFollowAccept(options?: Options) {
  const { callSdk } = useCallSdk();
  const queryClient = useQueryClient();
  const resolvedOptions = options ?? {};

  return useMutation({
    mutationFn: callSdk().postFanFollowAccept,
    ...resolvedOptions,
    // TanStack Query v5 hands onSuccess four arguments
    // (data, variables, onMutateResult, context). Forward all four. Dropping
    // the last one makes the caller's own onSuccess a type error at every
    // generated mutation hook.
    onSuccess: (data, variables, onMutateResult, context) => {
      resolvedOptions.onSuccess?.(data, variables, onMutateResult, context);
      invalidateRelated({ queryClient });
    },
  });
}
